import { METRIC_ID_KEY, getValueKeys } from '@portal/common/models/data-key';
import { PopulationRecords } from '@portal/common/models/data-type';
import { DataResponse, DataType } from '@portal/common/types';

import config from '../../config';

export default (response: Record<DataType, DataResponse>) => {
    const populationResponse = response[PopulationRecords];
    if (!populationResponse) {
        return response;
    }

    const { columns, records } = populationResponse;
    const metricIdx = columns.indexOf(METRIC_ID_KEY);

    const valuesIdxs = getValueKeys()
        .map((key) => columns.indexOf(key))
        .filter((idx) => idx !== -1);

    records
        .filter((record) => record[metricIdx] === config.numberMetricId)
        .forEach((record) => {
            valuesIdxs.forEach((idx) => {
                record[idx] = Math.round(record[idx]);
            });
        });

    return response;
};
